import { render, staticRenderFns } from "./ChangeStateOtherForm.vue?vue&type=template&id=676bf4ca&"
import script from "./ChangeStateOtherForm.vue?vue&type=script&lang=js&"
export * from "./ChangeStateOtherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports